<template>
  <div class="container">
    <div class="row">
      Doc
    </div>
  </div>

</template>

<script>
  export default {
    name: "DocView",
    components: {}
  }
</script>

<style>

</style>